import React, {useState,useEffect} from "react";
import { TextField, Button, Select, FormControl,InputLabel, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from "@material-ui/lab"
import { Constants } from "../utils/constants";
// import moment from "moment";
// import DateFnsUtils from '@date-io/date-fns';
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth()+1; //January is 0 so need to add 1 to make it 1!
var yyyy = today.getFullYear();

var todayMax = yyyy+ (mm < 10 ? '-0':'-')+mm+ (dd < 10 ? '-0': '-')+dd;
const useStyles = makeStyles((theme) => ({
    root: {
      width:"50%",
      display:"flex",   
      justifyContent:"center",
      alignSelf:"center",   
      '& > * + *': {
      marginTop: theme.spacing(2),
      },
    },
  }));

function ClientAppointment () {

    const classes = useStyles();

    const [firstName,setFirstName]= useState("");
    const [lastName,setlastName] = useState("")
    const [surName,setSurName] = useState("")
    const [fatherName,setFatherName] = useState("")
    const [gender,setGender] = useState("")
    const [dob,setDob]=useState()
    const [occupation,setOccupation] = useState("")
    const [email,setEmail] = useState("")
    const [address1,setAddress1] = useState("")
    const [address2,setAddress2] = useState("")
    const [country,setCountry] = useState("")
    const [areaName,setAreaName] = useState("")
    const [pincode,setPinCode] = useState("")
    const [mobileNo,setMobileNo] = useState("")
    const [doctorSlot,setDoctorData] = useState([])
    const [date1,setDate] = useState()
    const [time,setTime] = useState()
    const [doctorAvailability , setDoctorAvailability] = useState([])
    const [doctorProfile , setDoctorProfile] = useState([])
    const [doctorName , setDoctorName] = useState("")
    const [selectedDoctorId,setselectedDoctorId] = useState("")
    const [purposeOfVisit,setPurposeOfVisit]=useState("")
    const [errorMessage,setErrorMessage] = useState("")
    const [successMessage,setSuccessMessage] = useState("")
    // const [age,setAge] = useState("")
    useEffect(()=> {
        let url = Constants.CLIENT_DOCTOR_DETAILS_GET;
        fetch(url,
            {
          method:"GET",
          headers:{
            'Content-Type': 'application/json',
            'Authorization': Constants.CLIENT_AUTH_TOKEN
          }
        })
        .then(response => response.json())
        .then(data => { 
        //   setDoctorAvailability(data.data.doctor_availablity)
          setDoctorProfile(data.data.doctor_profile)

          setDoctorAvailability(data.data.doctor_availablity)
        });
      },[])     
     
    
     const clearData = () => {
        setFirstName("")
        setSurName("")
        setFatherName("")
        setGender("")
        setDob("")
        setOccupation("")
        setEmail("")
        setAddress1("")
        setAddress2("")
        setCountry("")
        setAreaName("")
        setPinCode("")
        setMobileNo("")
        setDate("")
        setTime()
        setDoctorName("")
        setPurposeOfVisit("")
     }
    const renderDoctorAvailable = (available) =>{
        var list = []
        for( let i = 0 ; i < 4; i++){
            var temp = "session_start_time_"+(i+1);
            if( available[temp]!= null){
               list.push(  
                  
                        <button style={{ marginLeft: 10, backgroundColor: time === available[temp] ? "#04b7b1" : "white" }} onClick={() => {
                           var tempSelect = "session_start_time_" + (i + 1);
                           setTime(available[tempSelect])
                       }}><text style={{color:time === available[temp] ? "white" :"black"}}>{available[temp]}</text></button> 
                   
                       
                   

                   
               )
            }
        }     
        return <div style={{flexDirection:"row", marginTop:3, marginBottom:20, width:500}}>
            {list}
        </div>;
    }
    const renderDoctorDetails=(item)=>{
          return(
              <div style={{ marginTop: 0 ,width:'40%'}}>
                  <div style={{width:500, flexDirection:'row', }}>
                      
                      <text style={{width:250,fontSize:18, fontWeight:500 }}>Select Appointment Date*:                                                              </text>
                
                      <input style={{width:250,padding:20}} type="date"min={todayMax} value={date1} onChange={(date) => { setDate(date.target.value) }} id={"date"} style={{ marginTop: 15 }} /> 
                      
                  </div>
                  <div style={{width:500, flexDirection:'row',marginTop:40}}>
                      
                      <text style={{width:250,fontSize:18, fontWeight:500 }}>Select Doctor*:                                                            </text>
                
                      <FormControl variant="outlined" style={{ marginLeft: 20}}>
                      <InputLabel htmlFor="outlined-age-native-simple"></InputLabel>
                      
                          <Select value = {selectedDoctorId +":"+doctorName}  
                          onChange={(data) => {
                             setDoctorName((data.target.value).split(":")[1])
                             setselectedDoctorId(parseInt((data.target.value).split(":")[0]))
                          }} label="Select Doctor" style={{ width: 250, height: 30 }}
                         >
                             {/* <option aria-label="Select Doctor"  /> */}
                            {item.map((doctor) => (
                             <MenuItem key={doctor.doctor_id} value={doctor.doctor_id +":"+doctor.first_name}>{doctor.first_name}</MenuItem>

                            ))}
   
                         </Select>
                      
                      
                  </FormControl>                      
              </div>
              </div>
          )
      }

      console.log("doctor_id",selectedDoctorId )
      console.log("doctor_name",doctorName )

      const handleClick = () => {
          setSuccessMessage("")
          setErrorMessage("")
          var gendershort = ""
          if(gender === "Female"){
            gendershort = "f"
          } else if(gender === "Male"){
            gendershort = "m"
          }else{
            gendershort = "Others"
          }

        let url = Constants.CLIENT_SIDE_APPOINTMENT_POST
        const data ={
            "doctor_id": selectedDoctorId,
            "message":purposeOfVisit,
            "date":date1,
            "time":time,
            "status":"unpaid",
            "patient_first_name": firstName,
            "patient_last_name": lastName,
            "patient_initial": surName,
            "father_husband_name": fatherName,
            "gender":gendershort ,
            "occupation": occupation,
            "dob":dob,
            "email":email,
            "address_line_1":address1,
            "address_line_2":address2,
            "area_name":areaName,
            "pincode":pincode,  
            "country":country,
            "mobile_number": mobileNo,
            "created_by":"Mathurai Eye Care"

        }
        fetch(url,
        {
          method:'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': Constants.CLIENT_AUTH_TOKEN
          },
          body:JSON.stringify(data),
        }
         
        )
        .then(response => response.json())
        .then(res => {
            if(res.status === "success"){
                    {clearData()}
                    setSuccessMessage(res.message)
                    setTimeout(() => {
                        setSuccessMessage("")
            }, 3000);
             }
             else{
                setErrorMessage(res.message)
                setTimeout(() => {
                    setErrorMessage("")
              }, 2000);
            }
          
        })
        .catch(err=>{
            console.log(err.message)
        })
   }

// var handleFindApproxDob = age => {
// console.log(age)
//     var year = 0;
//     var month = 0;
//     var days = 0;
//     var tempDate;
//     var approximate_date = moment();

//     // split data
//     var enteredDaySplit = age.split("/");

//     let yearsplit = enteredDaySplit[0] !== undefined ? enteredDaySplit[0] : ""
//     // year = yearsplit.length == 0 ? undefined : (parseInt(yearsplit) || 0);
//     year = parseInt(yearsplit) || 0;

//     let monthsplit = enteredDaySplit[1] !== undefined ? enteredDaySplit[1] : ""
//     // month = monthsplit.length == 0 ? undefined : (parseInt(monthsplit) || 0);
//     month = parseInt(monthsplit) || 0;

//     let daysplit = enteredDaySplit[2] !== undefined ? enteredDaySplit[2] : ""
//     // days = daysplit.length == 0 ? undefined : (parseInt(daysplit) || 0); 
//     days = parseInt(daysplit) || 0;

//     if (!year && !month && !days) {
//       tempDate = "";
//     } else {

//       // reset(year) year with difference year
//       approximate_date = moment(approximate_date).subtract(year, 'years');

//       // reset(month) month with difference month
//       approximate_date = moment(approximate_date).subtract(month, 'months');

//       // reset(days) days with difference days
//       approximate_date = moment(approximate_date).subtract(days, 'days');

//       tempDate = moment(approximate_date).format("DD-MM-YYYY");

//     }

//     return tempDate;
   
//   }

    return(
        
          <div style={{ backgroundColor:"white",display:"flex",flexDirection:"column" }}>
            <div style={{alignSelf:"center"}}>
             <h1  style={{ color:"#04b7b1", paddingTop:10}}>Appointment Booking</h1>
             
            </div>
            <div style={{paddingLeft:50, paddingTop:20, display:"flex",flexDirection:"row"}}>
            <div style={{ flexDirection:"row",flexWrap:"wrap",width:"70%",paddingTop: 10,borderWidth:1,borderLeftColor:"black"}}>
                
                <TextField id="standard-basic" label="First Name*" value={firstName} type="text" onChange={(firstName) => {
                     setFirstName(firstName.target.value) 
                    }} inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}  style={{width: '40%', marginLeft:20}}/>
                
                {/* <TextField id="standard-basic" label="Last Name" value={lastName} type="string" onChange={(lastName) => { setlastName(lastName.target.value) }}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}  style={{width: '40%', marginLeft:20}}/> */}
               
                <TextField id="standard-basic" label="Surname*" value={surName} type="string" onChange={(surName) => { setSurName(surName.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}  />
                  {/* <TextField id="standard-basic" label="Age*" value={age} type="number" onChange={(age) => { handleFindApproxDob(age) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}  /> */}
                <TextField id="standard-basic" label="Mobile Number*" type="number" value={mobileNo} onChange={(mobileNo) => {
                    if((mobileNo.target.value).length < 11){
                        setMobileNo(mobileNo.target.value)
                    }
                }}
                style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}} />

                <TextField id="standard-basic" label="Father/Husband" value={fatherName} type="string" onChange={(fatherName) => { setFatherName(fatherName.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}} />
                <div style={{marginLeft:20}}>
                <text style={{width:"20%",color:"gray"}}>Gender*</text>
                <FormControl variant="outlined" style={{ width: '30%', marginTop:15,marginLeft:20}}>
                      {/* <InputLabel htmlFor="outlined-age-native-simple">Gender</InputLabel> */}
                      <Select value={gender} onChange={(gender)=>{
                          setGender(gender.target.value)}} label="Gender" style={{width:'100%', fontSize:(gender ==='Gender')?10:14,height:30}}
                      >
                          <option aria-label="Gender" value={gender} />
                          <option value={"Male"}>Male</option>
                          <option value={"Female"}>Female</option>
                          <option value={"Others"}>Others</option>
                      </Select>
                  </FormControl>
                  <text style={{marginLeft:20,color:"gray"}}>DOB*:</text>
                  <input type="date" value={dob} id={"dob"} max={todayMax} onChange={(dob)=>{setDob(dob.target.value)}} style={{marginTop:15 ,marginLeft:20,width:"30%"}}/>
                </div>
                <TextField id="standard-
                basic" label="Occupation" value={occupation} onChange={(occupation) => { setOccupation(occupation.target.value) }} 
                style={{width: '40%',marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>
                
                
                <TextField id="standard-basic" label="Address 1" value={address1} onChange={(address1) => { setAddress1(address1.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>

               <TextField id="standard-basic" label="Email" value={email} onChange={(email) => { setEmail(email.target.value) }} 
                style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>


                <TextField id="standard-basic" label="Address 2" value={address2} onChange={(address2) => { setAddress2(address2.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>

                <TextField id="standard-basic" label
                ="Area Name*" value={areaName} onChange={(areaName) => { setAreaName(areaName.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>
               <TextField id="standard-basic" label="Pin Code" value={pincode} type="number" 
                 onChange={(pincode) => {
                    if((pincode.target.value).length < 7) 
                     setPinCode(pincode.target.value)
                 }}
                style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>
{/* 
                <TextField id="standard-basic" label="Country" value={country} onChange={(country) => { setCountry(country.target.value) }} style={{width: '40%', marginLeft:20}}
                inputProps={{style: {fontSize: 16}}} // font size of input text
                InputLabelProps={{style: {fontSize: 16}}}/>
                 */}
                 <div style={{marginLeft:20,marginTop:20,}}>
                 <text style={{width:"20%",color:"gray"}}>Country*:</text>
                <FormControl variant="outlined" style={{ width: '30%',marginLeft:20}}>            
                      <InputLabel htmlFor="outlined-age-native-simple"></InputLabel>
                      <Select value={country} onChange={(country)=>{
                          setCountry(country.target.value)}} label="Country" style={{width:'100%', fontSize:(country ==='country')?10:14,height:30}}
                      >
                         <option value={"India"}>India</option>
                      </Select>
                </FormControl>
                 </div>            
            </div>
            <div style={{width:"40%",borderLeftWidth:1,borderLeftColor:"gray",padding:50}}>
                    <div>
                        {doctorProfile.length > 0 && 
                            // if (item.id == selectedDoctorId) {
                                 renderDoctorDetails(doctorProfile)
                            // }
                        }
                    </div>
                    <div style={{marginTop:20}}>
                    <h5>Select Appointment Time*</h5>
                    
                    {doctorName === ""? 
                        <div>
                            <text style={{color:"lightgrey",marginLeft:10}}>Please select the doctor</text>
                        </div>:
                        <div>
                            {doctorAvailability.length > 0 && doctorAvailability.map((available, index) => {
                                if (available.doctor_id === selectedDoctorId) {
                                    console.log("available", available)
                                    return renderDoctorAvailable(available)
                                }
                            })}
                        </div>
                    } 
                        
                     
                    </div>
                    <div>
                        <h5>{"Purpose of Visit*"}</h5>
                        <textarea id="Purpose" maxLength={250} value={purposeOfVisit} name="purposeOfVisit" rows="4" cols="50" onChange={(purposeOfVisit)=>{setPurposeOfVisit(purposeOfVisit.target.value)}} style={{borderColor:"Gray",marginTop:10,paddingLeft:10 }}/>
                   </div>
                    
                 
            </div>
            </div>
            <div className={classes.root}>
                
                {successMessage ?
                    <Alert severity="success" onClose={() => {setSuccessMessage("")}} style={{width:"50%"}}>{successMessage}</Alert>
                    : null
                }
                {errorMessage ?
                    <Alert severity="error" onClose={() => {setErrorMessage("")}} style={{width:"50%"}}>{errorMessage}</Alert>
                    : null
                }

            </div>
            <div style={{flex:1,justifyContent:"center",alignSelf:"center",marginTop:50}}>
                <Button variant="contained" style={{ color:"white", backgroundColor:"#04b7b1" }}  href="#contained-buttons" onClick={() => {handleClick()}}>
                    Book An Appointment
                </Button>
            </div>

        </div>
    )
}
export default ClientAppointment;
